import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Urbanionrentinforround() {



    const cardData =
    {
        keyword: 'Urbania On Rent for Round Trip Pune',
        heading: 'Urbania on rent in pune: Urbania On Rent for Round Trip Pune',
        headingDescription: 'Urbania On Rent in Pune provides premium and reliable Urbania On Rent for Round Trip Pune services for corporate groups, families, tourists, and event travelers looking for seamless round-trip travel across the city and nearby destinations. Our well-maintained Force Urbania fleet offers spacious seating, air-conditioned comfort, and smooth performance, making it ideal for corporate outings, airport transfers, weddings, sightseeing, and outstation journeys from Pune. With professional chauffeurs, flexible round-trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a safe, punctual, and stress-free travel experience. Supported by 24/7 booking assistance, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the preferred choice for round-trip Urbania hire in Pune.',

        top: 'Top Places to Visit in Pune with Urbania on rent in pune',


 "topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort and a symbol of Maratha glory. Once the seat of Bajirao I’s administration, it features massive stone walls, grand gateways like the Delhi Darwaza, and lush lawns. Although much of it was destroyed in a fire, the remnants still echo royal grandeur. The evening light-and-sound show brings Maratha history to life. Shaniwar Wada stands as Pune’s proud emblem of heritage and valor."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Aga Khan Palace, constructed in 1892, is a monumental landmark tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum showcasing Gandhi’s personal artifacts and photographs. Its sprawling gardens and Italian arches make it a peaceful retreat. It also houses the samadhis of Kasturba Gandhi and Mahadev Desai. Aga Khan Palace is Pune’s symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The trust behind the temple is also known for its charitable work. Devotees find immense peace and blessings here. Dagdusheth Ganpati is the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Situated atop a rugged hill, Sinhagad Fort is famed for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors trek or drive up to explore its ancient ramparts, memorials, and scenic viewpoints. The fort offers breathtaking views of the Sahyadri ranges. Local vendors serve traditional pithla-bhakri meals near the summit. Sinhagad is Pune’s favorite blend of history, adventure, and nature."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings are a testament to early Indian craftsmanship. Pataleshwar is Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, showcasing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a major attraction. The museum is Pune’s living archive of art and craftsmanship."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill is one of Pune’s oldest landmarks, offering panoramic views of the city after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add to its cultural charm. Sunrise and sunset visits are especially mesmerizing. Parvati Hill is Pune’s spiritual and scenic high point."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across beautifully landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and transformation. Osho Ashram is Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers. Families and photography enthusiasts enjoy peaceful walks here. The garden beautifully blends Japanese aesthetics with Indian nature. It is Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot among locals. The vast waterscape and surrounding hills create a picturesque setting, especially during monsoon. Street vendors selling roasted corn and tea add to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy escape for weekends and sunsets."
  }
],



"services": [
    {
      "name": "Urbania on Rent for Round Trip Pune",
      "description": "Urbania on Rent for Round Trip Pune provides comfortable and reliable vehicles for round-trip travel within Pune or for outstation journeys. Ideal for families, groups, and corporate travelers, this service ensures spacious seating, professional chauffeurs, ample luggage space, and a smooth, stress-free journey for both legs of the trip."
    },
    {
      "name": "Round Trip Urbania Hire Pune",
      "description": "Round Trip Urbania Hire Pune offers flexible and convenient vehicle rental options for round trips. Perfect for corporate travel, family outings, and group tours, the service emphasizes punctual pickups, well-maintained vehicles, trained chauffeurs, and a comfortable journey without the need to arrange separate transportation for the return trip."
    },
    {
      "name": "Urbania Bus Rental Round Trip Pune",
      "description": "Urbania Bus Rental Round Trip Pune provides spacious buses suitable for large groups, corporate tours, and family outings. With ample seating, luggage space, safety features, and professional chauffeurs, these buses ensure a comfortable, organized, and enjoyable round-trip experience within Pune or to nearby destinations."
    },
    {
      "name": "Urbania AC Bus Round Trip Pune",
      "description": "Urbania AC Bus Round Trip Pune offers fully air-conditioned buses for maximum comfort during round-trip travel. Ideal for family trips, corporate teams, and tourists, these buses feature climate control, spacious seating, luggage storage, and experienced drivers for a smooth and relaxing journey both ways."
    },
    {
      "name": "Pune Round Trip Urbania Hire",
      "description": "Pune Round Trip Urbania Hire provides flexible round-trip transportation solutions for individuals, families, and corporate groups. Vehicles are well-maintained, spacious, and driven by professional chauffeurs, ensuring a safe, convenient, and stress-free journey for both legs of the trip within Pune or nearby areas."
    },
    {
      "name": "Corporate Round Trip Urbania Pune",
      "description": "Corporate Round Trip Urbania Pune provides professional transportation for business trips, corporate events, and team outings. Vehicles offer executive comfort, spacious seating, and trained chauffeurs, ensuring a smooth, productive, and reliable round-trip experience for corporate teams traveling in and around Pune."
    },
    {
      "name": "Family Round Trip Urbania Pune",
      "description": "Family Round Trip Urbania Pune ensures safe, comfortable, and spacious vehicles for family vacations and group trips. With courteous chauffeurs, ample luggage space, and well-maintained interiors, families can enjoy a stress-free round-trip journey while exploring Pune and its surrounding attractions."
    },
    {
      "name": "Luxury Round Trip Urbania Pune",
      "description": "Luxury Round Trip Urbania Pune provides high-end air-conditioned vehicles with plush interiors and superior ride quality for VIPs, executives, and travelers seeking premium comfort. Professional chauffeurs, smooth rides, and attention to detail guarantee a luxurious round-trip experience within Pune or nearby destinations."
    },
    {
      "name": "Affordable Round Trip Urbania Pune",
      "description": "Affordable Round Trip Urbania Pune delivers cost-effective round-trip transportation without compromising on comfort or reliability. Ideal for families, groups, and budget-conscious travelers, the service offers safe, clean vehicles and professional chauffeurs for a dependable and enjoyable journey."
    },
    {
      "name": "Chauffeur Driven Round Trip Urbania Pune",
      "description": "Chauffeur Driven Round Trip Urbania Pune offers stress-free travel with verified and experienced drivers. Vehicles are spacious, well-maintained, and suitable for round-trip journeys, allowing travelers to enjoy a safe, convenient, and comfortable ride without worrying about navigation or driving."
    },
    {
      "name": "Urbania for Local and Outstation Round Trip Pune",
      "description": "Urbania for Local and Outstation Round Trip Pune provides end-to-end transportation solutions for both local city travel and outstation trips. With reliable vehicles, experienced chauffeurs, punctual service, and luggage assistance, travelers can enjoy a smooth, comfortable, and efficient round-trip experience."
    },
    {
      "name": "Best Round Trip Urbania Rental Pune",
      "description": "Best Round Trip Urbania Rental Pune delivers top-rated round-trip travel services with a focus on reliability, comfort, and customer satisfaction. Suitable for families, corporate teams, and group travelers, it ensures smooth, safe, and punctual round-trip journeys, making it the preferred choice in Pune."
    },
    {
      "name": "Urbania Group Round Trip Travel Pune",
      "description": "Urbania Group Round Trip Travel Pune offers organized and comfortable transportation for group tours, corporate outings, and social events. Vehicles are spacious, well-maintained, and driven by professional chauffeurs, ensuring a hassle-free and enjoyable round-trip travel experience for large groups."
    },
    {
      "name": "Trusted Round Trip Urbania Service Pune",
      "description": "Trusted Round Trip Urbania Service Pune provides reliable, safe, and professional round-trip transportation services. With experienced chauffeurs, well-maintained vehicles, and timely service, travelers can enjoy peace of mind and a comfortable journey for both legs of their trip."
    },
    {
      "name": "Flexible Urbania Round Trip Hire Pune",
      "description": "Flexible Urbania Round Trip Hire Pune allows customizable travel options for round trips. Travelers can choose pick-up and drop-off locations, vehicle types, and timings to suit their schedule. With professional chauffeurs and well-maintained vehicles, the service ensures a convenient, comfortable, and hassle-free round-trip experience."
    }
  ],
  "tableData": [
    ["Urbania on Rent for Round Trip Pune", "Round Trip Urbania Hire Pune"],
    ["Urbania Bus Rental Round Trip Pune", "Urbania AC Bus Round Trip Pune"],
    ["Pune Round Trip Urbania Hire", "Corporate Round Trip Urbania Pune"],
    ["Family Round Trip Urbania Pune", "Luxury Round Trip Urbania Pune"],
    ["Affordable Round Trip Urbania Pune", "Chauffeur Driven Round Trip Urbania Pune"],
    ["Urbania for Local and Outstation Round Trip Pune", "Best Round Trip Urbania Rental Pune"],
    ["Urbania Group Round Trip Travel Pune", "Trusted Round Trip Urbania Service Pune"],
    ["Flexible Urbania Round Trip Hire Pune", ""]
  ],





"whychoose": [
    {
        "WhyChooseheading": "Reliable Urbania On Rent for Round Trip Pune",
        "WhyChoosedescription": "Urbania On Rent for Round Trip Pune is perfect for comfortable and spacious group travel, ideal for family outings, corporate trips, weddings, and city sightseeing."
    },
    {
        "WhyChooseheading": "Spacious and Comfortable Force Urbania Vehicles",
        "WhyChoosedescription": "Urbania On Rent for Round Trip Pune provides well-maintained Force Urbania vehicles with ample seating and luggage space, ensuring a smooth and hassle-free journey."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "Urbania On Rent for Round Trip Pune comes with skilled drivers familiar with Pune routes, ensuring safe, timely, and stress-free travel."
    },
    {
        "WhyChooseheading": "Transparent and Affordable Pricing",
        "WhyChoosedescription": "Choose Urbania On Rent for Round Trip Pune for competitive rates with no hidden charges, making group travel budget-friendly and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "Urbania On Rent for Round Trip Pune provides round-the-clock assistance for bookings, inquiries, and last-minute travel requirements."
    },
    {
        "WhyChooseheading": "Flexible Rental Packages",
        "WhyChoosedescription": "Urbania On Rent for Round Trip Pune is available for hourly trips, full-day bookings, corporate travel, wedding transportation, and customized city packages."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Vehicles",
        "WhyChoosedescription": "All Urbania vehicles for Pune round trips are regularly cleaned, sanitized, and serviced to ensure a safe and comfortable journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Urbania On Rent for Round Trip Pune guarantees timely pickups and dependable service, ensuring stress-free and smooth travel."
    }
]
}

const faqData = [
    {
        question: 'Is Urbania On Rent for Round Trip Pune suitable for local sightseeing?',
        answer: 'Yes, Urbania On Rent for Round Trip Pune is perfect for city tours, local sightseeing, and family outings within Pune.',
    },
    {
        question: 'How can I book Urbania On Rent for Round Trip Pune?',
        answer: 'You can book Urbania On Rent for Round Trip Pune via phone, WhatsApp, or online for quick and hassle-free reservations.',
    },
    {
        question: 'Why choose Urbania On Rent for Round Trip Pune for group travel?',
        answer: 'Urbania On Rent for Round Trip Pune provides ample seating, luggage space, and a smooth ride, making it ideal for family, corporate, and group travel.',
    },
    {
        question: 'Is Urbania On Rent for Round Trip Pune suitable for corporate and event travel?',
        answer: 'Yes, it is perfect for corporate trips, airport transfers, weddings, events, and one-day or multiple-hour round trips within Pune.',
    },
    {
        question: 'Are drivers experienced with Urbania On Rent for Round Trip Pune?',
        answer: 'Yes, all drivers are professionally trained, licensed, and experienced in handling Force Urbania vehicles to ensure safe and comfortable travel.',
    },
    {
        question: 'Can I customize pickup and drop-off locations with Urbania On Rent for Round Trip Pune?',
        answer: 'Absolutely. Urbania On Rent for Round Trip Pune allows flexible pickup and drop-off across Pune and nearby areas.',
    },
    {
        question: 'Is Urbania On Rent for Round Trip Pune available 24x7?',
        answer: 'Yes, Urbania On Rent for Round Trip Pune operates 24x7 to accommodate travel needs at any time.',
    },
    {
        question: 'Are hygiene and safety standards maintained for Urbania On Rent for Round Trip Pune?',
        answer: 'Yes, all vehicles are regularly cleaned, sanitized, and maintained with strict safety protocols for every trip.',
    },
    {
        question: 'What payment options are available for Urbania On Rent for Round Trip Pune?',
        answer: 'Urbania On Rent for Round Trip Pune accepts UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing options.',
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the journey to ensure a smooth and stress-free experience.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Kunal Sharma',
        feedback: 'We booked Urbania On Rent for Round Trip Pune for a family day out. The vehicle was spacious, clean, and extremely comfortable. Excellent service!',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Riya Deshmukh',
        feedback: 'Urbania On Rent for Round Trip Pune provided smooth and reliable service for our corporate outing. The driver was professional and punctual. Highly recommended!',
        rating: 5,
    },
];
































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Urbania On Rent for Round Trip Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/urbania-round-trip-pune.jpg",
  "description": "Urbania On Rent for Round Trip Pune offers AC and non-AC Urbania bus rental services for local and outstation round trips. Perfect for family tours, corporate trips, group travel, and luxury experiences. Chauffeur-driven Urbania buses ensure comfortable, safe, and affordable journeys for all types of round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "12000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/urbania-on-rent-round-trip-pune"
  }
};











    return (
        <div>

<Helmet>
  <title>
    Call:+91 9209423113 | Urbania On Rent for Round Trip Pune | AC & Luxury Urbania Bus Rental 
  </title>

  <meta
    name="description"
    content="Book Urbania On Rent for Round Trip Pune for local and outstation travel. AC and non-AC Urbania buses for family tours, corporate trips, group travel, and luxury experiences. Chauffeur-driven service ensures safe and comfortable journeys."
  />

  <meta
    name="keywords"
    content="Urbania on Rent for Round Trip Pune, Round Trip Urbania Hire Pune, Urbania Bus Rental Round Trip Pune, Urbania AC Bus Round Trip Pune, Pune Round Trip Urbania Hire, Corporate Round Trip Urbania Pune, Family Round Trip Urbania Pune, Luxury Round Trip Urbania Pune, Affordable Round Trip Urbania Pune, Chauffeur Driven Round Trip Urbania Pune, Urbania for Local and Outstation Round Trip Pune, Best Round Trip Urbania Rental Pune, Urbania Group Round Trip Travel Pune, Trusted Round Trip Urbania Service Pune, Flexible Urbania Round Trip Hire Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/38.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Urbanionrentinforround;